import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import theme from '../../themes/main';

export const ButtonContainer = styled.button`
  white-space: nowrap;
  border: 0;
  outline: 0;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  padding: 0 14px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, .11), 0 1px 3px rgba(0, 0, 0, .08);
  color: #fff;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  background-color: ${theme.palette.red};
  text-decoration: none;
  -webkit-transition: all 150ms ease;
  transition: all 150ms ease;
  margin-top: 10px;
  width: auto;

  &:hover {
    color: #fff;
    cursor: pointer;
    background-color: ${theme.palette.lightRed};
    transform: translateY(-1px);
    box-shadow: 0 7px 14px rgba(50, 50, 93, .10), 0 3px 6px rgba(0, 0, 0, .08);
  }
  &.absolute {
    position: absolute;
  }
  &.results {
    background-color: ${theme.palette.blueGrey};
    left: 0.5rem;
    top: 0.5rem;
    margin: 0;

    ${breakpoint('tablet')`
      left: 2rem;
      top: 2rem;
    `}

    &:hover {
      background-color: ${theme.palette.lightBlueGrey};
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/RyderButton/styledComponents.js